import { ChangeDetectionStrategy, Component } from "@angular/core";

import {
  ITab,
  TabNavigationComponent,
  TabNavigationStateService,
  tabNavigationStateServiceInjectionToken
} from "@zaeper/angular-dashboard-view-lib";
import { ZTemplateDirective } from "@zaeper/angular-core-lib";
import { AppsOverviewTabComponent } from "./tabs/apps-overview-tab/apps-overview-tab.component";
import { LauncherSettingsTabComponent } from "./tabs/launchers-overview-tab/launcher-settings-tab.component";
import { SystemTabComponent } from "./tabs/system-tab/system-tab.component";
import { appsOverviewStateServiceInjectionToken } from "./apps-overview-state-service-injection-token";
import { AppsOverviewStateService } from "./apps-overview-state.service";

@Component({
  selector: "app-applications-overview-modal",
  templateUrl: "./applications-overview-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TabNavigationComponent,
    ZTemplateDirective,
    AppsOverviewTabComponent,
    LauncherSettingsTabComponent,
    SystemTabComponent
],
  providers: [
    {
      provide: tabNavigationStateServiceInjectionToken,
      useClass: TabNavigationStateService
    },
    {
      provide: appsOverviewStateServiceInjectionToken,
      useClass: AppsOverviewStateService
    }
  ]
})
export class ApplicationsOverviewModalComponent {
  public tabs: ITab[] = [
    {
      title: "System",
      subject: "system"
    },
    {
      title: "Launcher",
      subject: "launcher"
    },
    {
      title: "Apps",
      subject: "apps"
    },
    {
      title: "Widgets",
      subject: "widgets"
    }
  ]
}
